import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/shared";
import StudentLayout from "@/components/StudentLayout";
import StaffLayout from "@/components/StaffLayout";

import Login from "@/pages/Login";
import Home from "@/pages/student/Home";
import Journey from "@/pages/student/Journey";
import Quests from "@/pages/student/Quests";
import QuestDetail from "@/pages/student/QuestDetail";
import SessionPage from "@/pages/student/SessionPage";
import Replays from "@/pages/student/Replays";
import Badges from "@/pages/student/Badges";
import Points from "@/pages/student/Points";
import Stories from "@/pages/student/Stories";
import Leaderboard from "@/pages/student/Leaderboard";
import Performance from "@/pages/student/Performance";
import Profile from "@/pages/student/Profile";
import Notifications from "@/pages/student/Notifications";

import StaffDashboard from "@/pages/staff/Dashboard";
import StaffStudents from "@/pages/staff/Students";
import StudentDetail from "@/pages/staff/StudentDetail";
import Reviews from "@/pages/staff/Reviews";
import Sessions from "@/pages/staff/Sessions";
import Attendance from "@/pages/staff/Attendance";
import StaffQuests from "@/pages/staff/QuestsManage";
import Announcements from "@/pages/staff/Announcements";
import Batches from "@/pages/staff/Batches";
import Teachers from "@/pages/staff/Teachers";
import ProgramBuilder from "@/pages/staff/ProgramBuilder";
import BadgeBuilder from "@/pages/staff/BadgeBuilder";
import PointRules from "@/pages/staff/PointRules";
import Reports from "@/pages/staff/Reports";

function RequireRole({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "student" ? "/app/home" : "/staff/dashboard"} replace />;
  }
  return children;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "student" ? "/app/home" : "/staff/dashboard"} replace />;
}

const S = (C) => <RequireRole roles={["student"]}><StudentLayout><C /></StudentLayout></RequireRole>;
const F = (C) => <RequireRole roles={["teacher", "admin"]}><StaffLayout><C /></StaffLayout></RequireRole>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />

          <Route path="/app/home" element={S(Home)} />
          <Route path="/app/journey" element={S(Journey)} />
          <Route path="/app/quests" element={S(Quests)} />
          <Route path="/app/quests/:id" element={S(QuestDetail)} />
          <Route path="/app/session/:id" element={S(SessionPage)} />
          <Route path="/app/replays" element={S(Replays)} />
          <Route path="/app/badges" element={S(Badges)} />
          <Route path="/app/points" element={S(Points)} />
          <Route path="/app/stories" element={S(Stories)} />
          <Route path="/app/leaderboard" element={S(Leaderboard)} />
          <Route path="/app/performance" element={S(Performance)} />
          <Route path="/app/profile" element={S(Profile)} />
          <Route path="/app/notifications" element={S(Notifications)} />

          <Route path="/staff/dashboard" element={F(StaffDashboard)} />
          <Route path="/staff/students" element={F(StaffStudents)} />
          <Route path="/staff/students/:id" element={F(StudentDetail)} />
          <Route path="/staff/reviews" element={F(Reviews)} />
          <Route path="/staff/sessions" element={F(Sessions)} />
          <Route path="/staff/attendance" element={F(Attendance)} />
          <Route path="/staff/quests" element={F(StaffQuests)} />
          <Route path="/staff/announcements" element={F(Announcements)} />
          <Route path="/staff/batches" element={F(Batches)} />
          <Route path="/staff/teachers" element={F(Teachers)} />
          <Route path="/staff/program" element={F(ProgramBuilder)} />
          <Route path="/staff/badges" element={F(BadgeBuilder)} />
          <Route path="/staff/points" element={F(PointRules)} />
          <Route path="/staff/reports" element={F(Reports)} />

          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
